module.exports = __webpack_public_path__ + "img/11.0e21e0a.png";